import {
  CreateInvoiceRequestBuilder,
  GetAllInvoicesRequestBuilder,
  GetInvoiceLogsBuilder,
  GetInvoicesCountRequestBuilder,
  GetInvoicesRequestBuilder,
  UpdateInvoiceRequestBuilder,
  GetInvoicesFileRequestBuilder,
  UpdateInvoiceStatusRequestBuilder,
  RemoveInvoiceRequestBuilder,
} from '../invoices/invoices';
import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class InvoicesRepository {
  getInvoices = async (actions: any) => {
    const makeInvoicesRequest = new GetAllInvoicesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const makeCountRequest = new GetInvoicesCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeInvoicesRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getAllInvoices = async (actions: any) => {
    const makeInvoicesRequest = new GetAllInvoicesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeInvoicesRequest);
    return response;
  };
  getInvoiceWithId = async (actions: any) => {
    const makeInvoicesRequest = new GetInvoicesRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeInvoicesRequest);

    return response;
  };
  getInvoiceFile = async (actions: any) => {
    const makeInvoicesRequest = new GetInvoicesFileRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token, 'blob');
    const response = await client.execute(makeInvoicesRequest);
    const blob = new Blob([response.data]);
    return blob;
  };
  updateInvoice = async (actions: any) => {
    const {data, body} = actions.payload;
    const makeUpdateInvoicesRequest = new UpdateInvoiceRequestBuilder()
      .params(body)
      .data(data.payload)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateInvoicesRequest);

    return response;
  };
  updateInvoiceStatus = async (actions: any) => {
    const {id, body} = actions.payload;
    const makeUpdateInvoicesRequest = new UpdateInvoiceStatusRequestBuilder()
      .params(body)
      .id(id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateInvoicesRequest);

    return response;
  };
  removeInvoice = async (actions: any) => {
    const {id} = actions.payload;
    const makeUpdateInvoicesRequest = new RemoveInvoiceRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateInvoicesRequest);

    return response;
  };
  createInvoice = async (actions: any) => {
    const {data, body} = actions.payload;
    const makeCreateInvoiceRequest = new CreateInvoiceRequestBuilder()
      .params(body)
      .data(data.payload)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeCreateInvoiceRequest);

    return response;
  };
  getLogs = async (actions: any) => {
    const makeRequest = new GetInvoiceLogsBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
}

export default new InvoicesRepository();
